import React, { useCallback, useState } from 'react';

import { Button } from '@mui/material';

import { InternalPromoWithDiscounts } from '~/services/PromoService';

import EmancipatePromoModal from './EmancipatePromoModal';

export interface EmancipatePromoButtonProps {
  childPromo: InternalPromoWithDiscounts;
  parentPromo: InternalPromoWithDiscounts;
  onSuccess: () => void | Promise<void>;
}

export default function EmancipatePromoButton({ childPromo, parentPromo, onSuccess }: EmancipatePromoButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = useCallback(() => setModalOpen(true), []);
  const handleClose = useCallback(() => setModalOpen(false), []);

  return (
    <>
      <Button variant="outlined" color="primary" size="small" onClick={handleOpen}>
        Emancipate from parent promo
      </Button>
      <EmancipatePromoModal
        open={modalOpen}
        onClose={handleClose}
        childPromo={childPromo}
        parentPromo={parentPromo}
        onSuccess={onSuccess}
      />
    </>
  );
}
